/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityFeedResponse } from '../../models/activity-feed-response';

export interface GetUnlockedActivities$Params {
  page: number;
  pageSize: number;
}

export function getUnlockedActivities(http: HttpClient, rootUrl: string, params: GetUnlockedActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityFeedResponse>>> {
  const rb = new RequestBuilder(rootUrl, getUnlockedActivities.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityFeedResponse>>;
    })
  );
}

getUnlockedActivities.PATH = '/api/activities/unlocked';
